import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import {
  CheckmarkCircleOutlineIcon,
  InfoIcon,
  VerifiedUserIcon,
} from "../../styles/icons";

interface AISuggestedMessageBannerProps {
  suggestedMessage: string;
  onUseSuggestedMessage: (message: string) => void;
}

export const AISuggestedMessageBanner: React.FC<AISuggestedMessageBannerProps> =
  ({ suggestedMessage, onUseSuggestedMessage }) => {
    return (
      <Box
        bg="gray.50"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        p={4}
        mt={2}
      >
        <VStack spacing={3} alignItems="flex-start" width="100%">
          <HStack spacing={2}>
            <VerifiedUserIcon color="riskRating.safe.icon" boxSize={5} />
            <Text fontSize="sm" fontWeight="bold" color="gray.700">
              AI-Suggested Message
            </Text>
          </HStack>
          <Text fontSize="sm" color="gray.700" pl={7}>
            {suggestedMessage}
          </Text>
          <Box pl={7}>
            <Button
              size="sm"
              onClick={() => onUseSuggestedMessage(suggestedMessage)}
              bg="white"
              color="black"
              borderColor="gray.300"
              borderWidth="1px"
              leftIcon={<CheckmarkCircleOutlineIcon />}
              _hover={{ bg: "gray.50" }}
              _active={{ bg: "gray.100" }}
            >
              Use this message
            </Button>
          </Box>
          <HStack spacing={1} pl={7} alignItems="flex-start">
            <InfoIcon color="blue.500" boxSize={3} mt="2px" />
            <Text fontSize="xs" color="gray.500">
              AI-suggested messages are not always 100% accurate and may be
              rated as &apos;Review Required&apos;. Please review before
              sending.
            </Text>
          </HStack>
        </VStack>
      </Box>
    );
  };
